import * as React from 'react';

const TrashcanIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <g stroke="#00B3E6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6.72 8.218H17.779M16.55 8.218v8.601c0 .679-.55 1.229-1.228 1.229H9.178c-.679 0-1.23-.55-1.23-1.229V8.218m1.844 0v-1.23c0-.678.55-1.228 1.229-1.228h2.457c.679 0 1.23.55 1.23 1.229v1.229M11.02 11.29v3.686M13.478 11.29v3.686" />
        </g>
      </g>
    </svg>
  );
};

export default React.memo(TrashcanIcon);
